import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

  export const getData = createAsyncThunk('documentTypes/getData', async (params) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/DocumentType/GetTableSummary', params, {mode:'cors'})
     
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const getDocumentType = createAsyncThunk('documentTypes/getDocumentType', async (params) => {
    
    const response = await axios.post(' https://api.zasway.com:8443/DocumentType/GetTableSummary', params, {mode:'cors'})
    
    return {
      
      params,
      data: response.data
    }
  })
  
  export const addDocument = createAsyncThunk('documentTypes/addDocument', async (Document) => {
    const response = await axios.post(' https://api.zasway.com:8443/DocumentType/Create', Document, {mode:'cors'})
    return response
  })

  export const editDocument  = createAsyncThunk('documentTypes/editDocument', async (Document) => {
    const response = await axios.post(' https://api.zasway.com:8443/DocumentType/Update', Document, {mode:'cors'})
    return response
  })
  
  export const deleteDocumentType = createAsyncThunk('documentTypes/deleteDocumentType', async (id) => {
    const response = await axios.post(' https://api.zasway.com:8443/DocumentType/Delete', id, {mode:'cors'})
    return response
  })

  export const getDocumentTypeEditData = createAsyncThunk('documentTypes/getDocumentTypeEditData', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/DocumentType/GetTableSummary', params, {mode:'cors'})
    return {
      data: response.data.data
    }
  })

  export const resetDocumentTypeEditData = createAsyncThunk('documentTypes/resetDocumentTypeEditData', async () => {
    return {
      data: []
    }
  })

  export const getOwnerTypeList = createAsyncThunk('documentTypes/getOwnerTypeList', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetOwnerTypeList', params)
    return response.data
  })

  export const documentTypesSlice = createSlice({
    name: 'documentTypes',
    initialState: {
      documentTypeData: [],
      DocumentData: [],
      documentTypeEditData: [],
      DocumentEditData: [],
      DocumentEditDataAllData: [],
      data: [],
      total: 1,
      params: {},
      allData: [],
      selectedUser: null,
      selectedDocument:[],
      IsSaved:0
    },
      reducers: {},
      extraReducers: builder => {
  
      builder
        // .addCase(getData.fulfilled, (state, action) => {
        //   state.DocumentEditData = action.payload.data
        // })
        .addCase(getData.fulfilled, (state, action) => {
         
          state.data = action.payload.data
          state.params = action.payload.params
          state.total = action.payload.totalPages
        })

        .addCase(editDocument.fulfilled, (state, action) => {
          state.data = action.payload.data
        })

        .addCase(getDocumentType.fulfilled, (state, action) => {
          state.DocumentData = action.payload.data
        })

        .addCase(getDocumentTypeEditData.fulfilled, (state, action) => {
          state.documentTypeEditData = action.payload.data
        })

        .addCase(resetDocumentTypeEditData.fulfilled, (state, action) => {
          state.documentTypeEditData = action.payload.data
        })
      }
  })
    
  export default documentTypesSlice.reducer